import * as BABYLONGUI from 'babylonjs-gui';
class XmlLoader2 extends BABYLONGUI.XmlLoader {
    public loadLayoutFromString(xmlContent: string, rootNode: any) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlContent, "application/xml");
        (this as any)._parseXml(xmlDoc.documentElement.firstChild, rootNode);
        (this as any)._isLoaded = true;
    }
}

export default XmlLoader2;